import React, { Fragment, useEffect, useState, useReducer } from "react";
import { useStyletron } from "baseui";
import { FormControl } from "baseui/form-control";
import { Input, SIZE as INPUT_SIZES } from "baseui/input";
import { Select } from "baseui/select";
import { styled } from "styletron-react";
import { LabelMedium } from "baseui/typography";
import { Textarea, SIZE as TEXT_SIZE } from "baseui/textarea";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import { BlockProps } from "baseui/block";
import ChevronRight from "baseui/icon/chevron-right";
import { SIZE } from "baseui/drawer";
const InputDiv = styled(FlexGridItem, {
  // margin: "5px",
});

export default function NumericInputTemplate({
  handleItemPropsChanged,
  ...props
}) {
  const [name, setName] = useState(props.name);
  const [displayName, setDisplayName] = useState(props.displayName);
  const [defaultValue, setDefaultValue] = useState(props.defaultValue);
  const [minValue, setMinValue] = useState(props.minValue);
  const [maxValue, setMaxValue] = useState(props.maxValue);
  const [step, setStep] = useState(props.step ?? 1);
  const [description, setDescription] = useState(props.description);
  const [, setExpanded] = React.useState(props.isSelected);
  const [css] = useStyletron();
  const [error, setError] = useState({...props.errors["common"], ...props.errors["numeric"]});

  useEffect(() => {
    setExpanded(props.isSelected);
    setName(props.name);
    setDisplayName(props.displayName);
    setDefaultValue(props.defaultValue);
    setMinValue(props.minValue);
    setMaxValue(props.maxValue);
    setStep(props.step || 1);
    setDescription(props.description);
  }, [
    props.isSelected,
    props.name,
    props.displayName,
    props.defaultValue,
    props.minValue,
    props.maxValue,
    props.step,
    props.description,
  ]);

  useEffect(() => {
    setError({...props.errors["common"], ...props.errors["numeric"]});
  }, [props.errors]);


  function handleItemChange() {
      console.log(props);
      var item = {
        id: props.id,
        name: name,
        displayName: displayName,
        defaultValue: defaultValue,
        minValue: minValue,
        maxValue: maxValue,
        step: step,
        description: description,
      };
      handleItemPropsChanged(props.type, item);
    }
  // useEffect(() => {
  //   setItem(props);
  // }, [props]);
  return (
    <Fragment>
      <FlexGrid flexGridColumnCount={[1, 2, 2, 3]} flexGridColumnGap="scale800">
        <InputDiv>
          <FormControl
            label="Parameter name"
            caption={
              error.name
                ? "Parameter name should be alphanumeric and unique"
                : ""
            }
            error={error.name}
          >
            <Input
              type="text"
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setName(e.target.value)}
              value={name}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl label="Display name">
            <Input
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setDisplayName(e.target.value)}
              value={displayName}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl
            label="Default value"
            caption={
              error.defaultValue
                ? "Default value should be between min and max values."
                : ""
            }
            error={error.defaultValue}
          >
            <Input
              type="number"
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setDefaultValue(e.target.value)}
              value={defaultValue}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl
            label="Minimum value"
            caption={
              error.minValue ? "Min value should be less than max value." : ""
            }
            error={error.minValue}
          >
            <Input
              type="number"
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setMinValue(e.target.value)}
              value={minValue}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl
            label="Maximum value"
            caption={
              error.maxValue
                ? "Max value should be greater than min value."
                : ""
            }
            error={error.maxValue}
          >
            <Input
              type="number"
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setMaxValue(e.target.value)}
              value={maxValue}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
        <InputDiv>
          <FormControl 
          label="Step"
          caption={
            error.step
              ? "Step should have a valid value."
              : ""
          }   
          error={error.step}       
          >
            <Input
              type="number"
              min={0.1}
              step={0.1}
              disabled={!props.isSelected}
              onBlur={handleItemChange}
              onChange={(e) => setStep(e.target.value)}
              value={step}
              size={INPUT_SIZES.mini}
            />
          </FormControl>
        </InputDiv>
      </FlexGrid>
      <div>
        <FormControl label="Description">
          <Textarea
            disabled={!props.isSelected}
            onBlur={handleItemChange}
            onChange={(e) => setDescription(e.target.value)}
            value={description || ""}
            size={TEXT_SIZE.mini}
            clearOnEscape
          />
        </FormControl>
      </div>
    </Fragment>
  );
}
